<template>
    <div class="row">
        <div class="card">
            <div class="card-header flex flex-col justify-between items-center">
                <h2>Lista de Vídeos</h2>
                <router-link
                    to="/sistema/videos/novo-video"
                    class="btn btn-primary"
                    >Novo Vídeo</router-link
                >
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="videos.columns"
                    :rows="videos.rows"
                    :totalRows="videos.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum vídeo foi cadastrado ainda.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field === 'categoria'"></div>

                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-col"
                        >
                            <div
                                class="h-6  mb-2"
                                title="Editar Vídeo"
                                @click.prevent="
                                    () =>
                                        $router.push(
                                            `/sistema/videos/editar-video/${props.row.id}`
                                        )
                                "
                            >
                                <svg-icon
                                    icon="pencil"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                            <div
                                class="h-6"
                                title="Excluir Vídeo"
                                @click="deleteVideo(props.row)"
                            >
                                <svg-icon
                                    icon="delete"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";

export default {
    name: "listar-videos",
    components: {
        VueGoodTable
    },
    data() {
        return {
            videos: {
                columns: [
                    {
                        label: "Título",
                        field: "titulo"
                    },
                    {
                        label: "Url",
                        field: "url"
                    },
                    {
                        label: "Descrição",
                        field: "descricao"
                    },
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false,
                        width: "5%"
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },
    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarVideos({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarVideos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarVideos({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os vídeos conforme as mudanças
         * @param newProps
         */
        filtrarVideos(newProps) {
            this.videos.filtros = Object.assign(
                {},
                this.videos.filtros,
                newProps
            );
            this.getVideos();
        },

        getVideos() {
            this.axios
                .get("/videos", {
                    params: {
                        page: this.videos.filtros.page,
                        per_page: this.videos.filtros.perPage,
                        sortField: this.videos.filtros.sort.field,
                        sortType: this.videos.filtros.sort.type
                    }
                })
                .then(response => {
                    this.videos.rows = response.data.video.data;
                    this.videos.total = response.data.video.total;
                });
        },

        deleteVideo(row) {
            this.$swal({
                title: "Excluir Vídeo",
                text: "Você deseja excluir esta vídeo?",
                icon: "question",
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: "#6C9E1D",
                cancelButtonColor: "#E50053",
                cancelButtonText: "Não",
                confirmButtonText: "Sim"
            }).then(result => {
                if (result.value) {
                    this.axios
                        .delete(`/videos/${row.id}`)
                        .then(response => {
                            this.$swal({
                                title: "Sucesso",
                                text: "O vídeo foi excluido com sucesso!",
                                icon: "success"
                            });
                            this.videos.rows.splice(row.originalIndex, 1);
                        })
                        .catch(error => {
                            this.$swal({
                                title: "Algo de errado ocorreu",
                                text: error.response.data.message,
                                icon: "error"
                            });
                        });
                }
            });
        }
    },
    mounted() {
        this.getVideos();
    }
};
</script>
<style lang="scss" scoped>
.card-header {
    @media (min-width: 500px) {
        @apply flex-row;
    }
}
</style>
